import { FormValues } from '../hooks/useForm';
import { API } from './api';

export class ContatoService {
  public async send(
    body: FormValues,
  ): Promise<{ mensagem: string; sucesso: boolean }> {
    try {
      const { data } = await API.post('/contato', body);
      return data;
    } catch (error) {
      console.error('Error sending contact form:', error);
      return {
        mensagem: 'Erro ao enviar o formulário de contato.',
        sucesso: false,
      };
    }
  }
}
